// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3gnKK","question":"Question_question__1RRy2","description":"Question_description__3QubJ"};